/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'home-tick': {
    width: 14.383,
    height: 12.706,
    viewBox: '0 0 14.383 12.706',
    data: '<path pid="0" data-name="Path 3393" d="M13.755.097c-.649-.349-1.373.325-1.8.724-.974.949-1.8 2.047-2.721 3.046-1.023 1.1-1.972 2.2-3.021 3.27a9.006 9.006 0 0 0-1.648 2 32.767 32.767 0 0 0-2.666-2.603c-.724-.549-1.922-.949-1.9.374.05 1.723 1.573 3.57 2.7 4.743a2.851 2.851 0 0 0 1.819 1.053c.874.05 1.772-1 2.3-1.573.924-1 1.673-2.122 2.521-3.145 1.1-1.348 2.222-2.671 3.3-4.044.666-.849 2.788-2.946 1.116-3.845zM1.099 6.813a.189.189 0 0 0-.1.021 1.215 1.215 0 0 1-.275-.1q.112-.071.375.079z" _fill="#707070"/>'
  }
})
